import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {Result, Spin} from 'antd';
import b2cAccountService from '../../services/b2cAccountService';
import BackToApp from './BackToApp';
import './AuthPages.css';

/**
 * Cel linku „potwierdź adres" z e-maila. Strona nie loguje nikogo, więc po
 * potwierdzeniu odsyła z powrotem do aplikacji na telefonie.
 */
function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setErrorMessage('Brak tokenu weryfikacyjnego.');
      return;
    }

    b2cAccountService.verifyEmail(token)
      .then(() => setStatus('success'))
      .catch((error) => {
        setStatus('error');
        setErrorMessage(error.response?.data?.message || 'Weryfikacja nie powiodła się.');
      });
  }, [searchParams]);

  return (
    <div className="auth-page">
      <div className="auth-card">
        {status === 'loading' && (
          <div style={{textAlign: 'center', padding: 40}}>
            <Spin size="large" />
            <p style={{marginTop: 16}}>Weryfikacja konta...</p>
          </div>
        )}
        {status === 'success' && (
          <Result
            status="success"
            title="E-mail zweryfikowany!"
            subTitle="Konto jest aktywne. Wróć do aplikacji MyBeautyPlace na telefonie i zaloguj się."
            extra={<BackToApp />}
          />
        )}
        {status === 'error' && (
          <Result
            status="error"
            title="Weryfikacja nie powiodła się"
            subTitle={errorMessage}
            extra={<BackToApp text="Nowy link wyślesz z aplikacji na telefonie." />}
          />
        )}
      </div>
    </div>
  );
}

export default VerifyEmailPage;
